var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Fix") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.2,239.3,265.85,57.93a14.28,14.28,0,0,0-19.7,0L55.8,239.3A9.11,9.11,0,0,0,62.09,255H449.91A9.11,9.11,0,0,0,456.2,239.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.12,229.22V447.15A10.86,10.86,0,0,0,128,458h61.77a10.86,10.86,0,0,0,10.86-10.86v-122a10.86,10.86,0,0,1,10.86-10.86h89a10.86,10.86,0,0,1,10.86,10.86v122A10.86,10.86,0,0,0,322.24,458H384a10.86,10.86,0,0,0,10.86-10.86V229.22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 374.01,
    width: 23,
    height: 23,
    rx: 11.5,
    ry: 11.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.120bcafb.svg";
export { ForwardRef as ReactComponent };